import React, { createContext, isValidElement, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useStableCallbacks } from "../utils/useStableCallbacks";
import { GlobalContext } from "./GlobalContext";
import { useAuth } from "./AuthContext";
import { axiosInstance } from "../axios/axiosInstance";
import { WishlistContext } from "./WishlistContext";
import { clearLoginReturnUrl, isValidArray, showWishListAddToaster } from "../Layout/Common/common";
import { useFlashLoaderLoader } from "./FlashScreenContext";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGES } from "../routeConfig";
import axios from "axios";
import { debounce } from "lodash";
import { fetchProducts, fetchTrendingProducts } from "../Layout/Common/algoliaInstantLib";
import { useOrderClarificationModal } from "./OrderClarificationPopUpContext";
import { showErrorSnackbar, showSuccessSnackbar } from "../utils/snackbarNotifications";
import { showRemoveItemToast } from "../utils/cartToastManager";
import { useNoteAlert } from "./pleaseNote";
import { clearAll as clearOrderHistoryCache } from "../View/MyAccount/MyOrderList/orderHistoryCache";
import { takePendingShippingAddress } from "./hook/tillRedirect";

const GlobalFunctionContext = createContext();

export const GlobalFunctionProvider = ({ children }) => {
  const globalcontext = useContext(GlobalContext);
  const { showNoteAlert } = useNoteAlert();
  const {
    clarificationItem,
    setCategorySlider,
    setClarificationItem,
    CartItem,
    setCartItem,
    OrderId,
    setCompatibleList,
    setAddressList,
    refreshable,
    setRefreshable,
    setLinkedCategoryData,
    setNewCategoryData,
  } = useContext(GlobalContext);
  const {
    isAuthenticated,
    userId,
    companyId,
    setUser,
    setAthuLoading,
    emailAddress,
    userRole,
    authLoading,
    priceCode,
  } = useAuth();
  const { wishlistState, dispatch } = useContext(WishlistContext);
  const historyNavigate = useNavigate();
  const location = useLocation();
  const { showLoader, hideLoader } = useFlashLoaderLoader();
  const { setIsOrderClarification } = useOrderClarificationModal();
  const refreshRef = useRef(null);
  const clientCartItemRef = useRef(null);
  const aerosolRequestRef = useRef(0);
  const pickupOnlyRequestRef = useRef(0);
  const cartProductsKeyRef = useRef(null);
  const handleAddtoCart = useCallback(
    async (pid, qty, type) => {
      const params = {
        userid: String(userId),
        productId: String(pid),
        qty: parseInt(qty),
        key: type,
      };

      const response = await axiosInstance.post("AddtoCart/AddtoCart", params);
      if (response.data !== -1) {
        localStorage.setItem("CART_ITEM", JSON.stringify(response.data.cartItem));
        globalcontext.setCartItem(response.data);
        return null;
      } else {
        alert("Something went wrong!");
        return null;
      }
    },
    [userId],
  );

  const SubUrbDataAll = (txt) => {
    axiosInstance
      .post("Shipping/loadSuburb?txt=" + txt, txt)
      .then((response) => {
        if (response.data !== "") {
          globalcontext.setSuburbList(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  const getCountryList = () => {
    axiosInstance
      .get("AddressBook/getCountryList")
      .then((response) => {
        if (response.data !== "") {
          globalcontext.setCountryList(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  const loadBillAddress = async () => {
    await axiosInstance
      .post("Shipping/getBillingAddress", { userId: String(userId) })
      .then((response) => {
        if (response.data !== "") {
          globalcontext.setBillingAddress(response.data);
          globalcontext.setBillingAddressOriginal(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  const fetchBillinfo = (orderId) => {
    if (!orderId) return;
    var params = {
      userId: String(userId),
      orderId: String(orderId),
    };

    axiosInstance
      .post("Shipping/GetBillInfo", params)
      .then((response) => {
        if (response && response.data) {
          globalcontext.setBillInfo(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  const getMyAddressBook = async () => {
    var response = await axiosInstance.post("AddressBook/GetAddressBookList", {
      userId: String(userId),
    });
    if (response && response.data) {
      setAddressList(response.data);
      return response.data;
    } else {
      setAddressList([]);
      return null;
    }
  };
  const getEditAddressBook = async (id) => {
    var response = await axiosInstance.post("AddressBook/GetAddressBook", {
      userId: String(userId),
      id: parseInt(id),
    });
    if (response && response.data) {
      return response.data;
    } else return null;
  };

  const saveAddressBook = async (values, id = 0) => {
    try {
      var address = { ...values, id: 0 };
      var params = {
        userId: String(userId),
        address: address,
        id: id ?? 0,
      };
      var response = await axiosInstance.post("AddressBook/UpdateAddress", params);
      return response;
    } catch (e) {}
    return null;
  };

  const sendAddressUpdateOTP = async () => {
    var response = await axiosInstance.post("MailSend/SendMailOTP", {
      userId: String(userId),
    });
    if (response && response.data) {
      return response.data;
    } else return null;
  };
  const updateAddressMail = async (otp, address) => {
    var response = await axiosInstance.post("MailSend/updateAddressMail", {
      userId: String(userId),
      otp: otp,
      address: address,
    });
    if (response && response.data) {
      return response.data;
    } else return null;
  };
  const loadAllWishList = () => {
    var data = { userid: parseInt(userId) };
    axiosInstance
      .post("MyFavoriteList/GetFavouriteList", data)
      .then((response) => {
        if (response.data) {
          globalcontext.setWishListAll(response.data);
        }
      })
      .catch((error) => {
        return error.message;
      });
  };

  const getAllWishList = async () => {
    try {
      var data = { userid: parseInt(userId) };
      const response = await axiosInstance.post("MyFavoriteList/GetFavouriteList", data);
      if (response && response.data) return response.data;
      else return null;
    } catch (e) {
      console.error(e);
    }
  };
  const createNewList = async (listName) => {
    try {
      var data = { userid: parseInt(userId), listName: listName };
      const response = await axiosInstance.post("MyFavoriteList/AddNewList", data);
      if (response && response.data) return response.data;
      else return null;
    } catch (e) {
      console.error(e);
    }
  };

  const deleteNewList = async (listId) => {
    try {
      var data = { userid: parseInt(userId), listId: parseInt(listId) };
      const response = await axiosInstance.post("MyFavoriteList/DeleteList", data);
      if (response && response.data) return response.data;
      else return null;
    } catch (e) {
      console.error(e);
    }
  };

  const handleWishList = useCallback(
    (action, productId) => {
      dispatch({
        type: action === "ADD" ? "ADD_TO_WISHLIST" : "REMOVE_FROM_WISHLIST",
        productId,
        showAlert: true,
      });
      var params = {
        userid: userId,
        productid: parseInt(productId),
        action: action,
      };

      axiosInstance
        .post("MyFavoriteList/AddToWhishList", params)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            globalcontext.setWishList(response.data);
          }
        })
        .catch((error) => console.log(error.message));
    },
    [userId],
  );
  const removwItemWhishList = useCallback(
    async (action, productId) => {
      try {
        dispatch({
          type: action === "ADD" ? "ADD_TO_WISHLIST" : "REMOVE_FROM_WISHLIST",
          productId,
          showAlert: true,
        });
        var params = {
          userid: userId,
          productid: parseInt(productId),
          action: action,
        };
        var response = await axiosInstance.post("MyFavoriteList/AddToWhishList", params);
        if (response && response.data) {
          globalcontext.setWishList(response.data);
          return response.data;
        } else {
          return null;
        }
      } catch (e) {
        console.error(e);
      }
    },
    [userId],
  );
  const pendingDeletesRef = useRef(new Map());
  const pendingResolversRef = useRef(new Map());
  const [deletingProdIds, setDeletingProdIds] = useState(() => new Set());
  const userIdRef = useRef(userId);
  const orderIdRef = useRef(OrderId);
  const showNoteAlertRef = useRef(showNoteAlert);
  const refreshCartItemRef = useRef(null);
  useEffect(() => {
    userIdRef.current = userId;
  }, [userId]);

  useEffect(() => {
    orderIdRef.current = OrderId;
  }, [OrderId]);

  useEffect(() => {
    showNoteAlertRef.current = showNoteAlert;
  }, [showNoteAlert]);

  const flushPendingDeletesRef = useRef(null);
  if (!flushPendingDeletesRef.current) {
    flushPendingDeletesRef.current = debounce(async () => {
      const batch = Array.from(pendingDeletesRef.current.values());
      pendingDeletesRef.current.clear();
      if (batch.length === 0) return;

      const succeeded = new Set();
      const failedMessages = [];
      try {
        const response = await axiosInstance.post("MyCart/RemoveItems", {
          userId: String(userIdRef.current),
          orderId: String(orderIdRef.current),
          items: batch.map((item) => ({
            productId: String(item.productId),
            orderItemId: String(item.orderItemId ?? ""),
          })),
        });
        const data = response?.data;
        if (data?.statusCode === 1) {
          (data.succeeded || []).forEach((pidStr) => {
            const pid = parseInt(pidStr, 10);
            if (!Number.isNaN(pid)) succeeded.add(pid);
          });
          (data.failed || []).forEach((f) => {
            if (f?.message) failedMessages.push(f.message);
          });
        } else if (data?.message) {
          failedMessages.push(data.message);
        }
      } catch (error) {
        const msg = error?.response?.data?.message || error?.message;
        if (msg) failedMessages.push(msg);
        else console.error(error);
      }

      if (succeeded.size > 0) {
        const toastPids = new Set(
          batch.filter((item) => item.showToast !== false).map((item) => parseInt(item.productId, 10)),
        );
        setCartItem((prev) => {
          if (!prev || !Array.isArray(prev.cartItem)) return prev;
          const removed = prev.cartItem.filter((ci) => succeeded.has(ci.prod_id));
          removed.forEach((ci) => {
            if (toastPids.has(ci.prod_id)) showRemoveItemToast(ci);
          });
          const remaining = prev.cartItem.filter((ci) => !succeeded.has(ci.prod_id));
          return { ...prev, cartItem: remaining, totalItem: remaining.length };
        });
      }

      batch.forEach((item) => {
        const pid = parseInt(item.productId, 10);
        const ok = succeeded.has(pid);
        const resolvers = pendingResolversRef.current.get(pid) || [];
        resolvers.forEach((res) => res(ok));
        pendingResolversRef.current.delete(pid);
      });

      setDeletingProdIds((prev) => {
        const next = new Set(prev);
        batch.forEach((item) => next.delete(parseInt(item.productId, 10)));
        return next;
      });

      failedMessages.forEach((msg) => {
        if (showNoteAlertRef.current) showNoteAlertRef.current(msg);
        else console.error(msg);
      });

      if (succeeded.size > 0 && refreshCartItemRef.current) {
        refreshCartItemRef.current();
      }
    }, 1000);
  }
  const flushPendingDeletes = flushPendingDeletesRef.current;

  useEffect(() => () => flushPendingDeletes.cancel(), [flushPendingDeletes]);

  const handleDeleteCartItem = useCallback(
    (productId, itemId, showToast = true) => {
      const pid = parseInt(productId, 10);
      pendingDeletesRef.current.set(pid, { productId, orderItemId: itemId, showToast });
      setDeletingProdIds((prev) => {
        if (prev.has(pid)) return prev;
        const next = new Set(prev);
        next.add(pid);
        return next;
      });
      flushPendingDeletes();
      return new Promise((resolve) => {
        const list = pendingResolversRef.current.get(pid) || [];
        list.push(resolve);
        pendingResolversRef.current.set(pid, list);
      });
    },
    [flushPendingDeletes],
  );

  const checkArosol = useCallback(
    async (cartItem) => {
      const requestId = ++aerosolRequestRef.current;
      var params = {
        orderId: String(cartItem.orderid),
        userId: String(userId),
      };
      axiosInstance
        .post("Shipping/CheckArosol", params)
        .then((response) => {
          if (requestId !== aerosolRequestRef.current) return;
          globalcontext.setAerosol(isValidArray(response.data) ? response.data : null);
        })
        .catch((error) => {
          if (requestId !== aerosolRequestRef.current) return;
          globalcontext.setAerosol(null);
        });
    },
    [userId],
  );

  const checkPickupOnly = useCallback(
    (cartItem) => {
      const requestId = ++pickupOnlyRequestRef.current;
      var params = {
        orderId: String(cartItem ? cartItem.orderid : 0),
        userId: String(userId),
      };
      axiosInstance
        .post("Shipping/CheckPickupOnly", params)
        .then((response) => {
          if (requestId !== pickupOnlyRequestRef.current) return;
          if (response.data !== null) {
            globalcontext.setPickupOnlyProduct(response.data);
          } else {
            globalcontext.setPickupOnlyProduct([]);
          }
        })
        .catch((error) => {
          if (requestId !== pickupOnlyRequestRef.current) return;
          globalcontext.setPickupOnlyProduct([]);
        });
    },
    [userId],
  );

  const getShippingAddress = useCallback(() => {
    var params = {
      userId: String(userId),
    };
    globalcontext.setShippingAddress(null);
    axiosInstance
      .post("Shipping/getShippingAddress", params)
      .then((response) => {
        if (response.data) {
          const restoredAddress = takePendingShippingAddress();
          globalcontext.setShippingAddress(restoredAddress || response.data);
          globalcontext.setShippingAddressOriginal(response.data);
        } else {
        }
      })
      .catch((error) => console.error(error.message));
  }, [userId]);

  const get04MobileNumber = () => {
    var params = {
      userId: String(userId),
    };
    globalcontext.setSmsNumber(null);
    axiosInstance
      .post("Shipping/GetMobileNumber", params)
      .then((response) => {
        if (response.data) {
          globalcontext.setSmsNumber(response.data);
        } else {
          globalcontext.setSmsNumber("");
        }
      })
      .catch((error) => console.error(error.message));
  };

  const checkOrderNoMandatory = async () => {
    await axiosInstance
      .post("Shipping/CheckOrderIdNeeded", {
        userid: String(userId),
      })
      .then((response) => {
        if (response.data !== null) {
          globalcontext.setPoNumberRequired(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };
  const get_po_number_rules = async () => {
    await axiosInstance
      .post("Shipping/get_po_number_rules", {
        userid: String(userId),
        companyId: String(companyId),
      })
      .then((response) => {
        if (response.data !== null) {
          globalcontext.setPoNumberRules(response.data);
          return response.data;
        }
      })
      .catch((error) => console.log(error.message));
  };
  const submitOrderMailSend = async (oid) => {
    var data = {
      userid: String(userId),
      orderid: String(oid),
    };
    axiosInstance
      .post("Shipping/OrderMailSend", data)
      .then((response) => {})
      .catch((error) => console.log(error.message));
  };
  const logoutReset = () => {
    globalcontext.setCartItem(null);
    clearSelectedShipService();
    globalcontext.setPaymentOption(null);
    globalcontext.setSelectedCard(null);
    globalcontext.setNewcardSave(false);
    globalcontext.setChangeShipServiceClicked(true);
    globalcontext.setNewcardSave(false);
    globalcontext.setIsInterNational(false);
    globalcontext.setPoNumberRequired(false);
    globalcontext.setNewcardName("");
    globalcontext.setNewcardExp("");
    globalcontext.setChangeAddressClicked(false);
    globalcontext.setAddressType(null);
    globalcontext.setSelectedAddressId(null);
    globalcontext.setNewAddress(null);
    globalcontext.setAddressOrderId(null);
    globalcontext.shownPreviousOrderPopup.current = false;
  };
  const logoutFunction = async () => {
    try {
      clearOrderHistoryCache();
      const responce = await axios.post(window.location.origin + "/api/Logout");
      if (responce) return responce;
    } catch (e) {
      console.error(e);
    }
  };
  const logout = async () => {
    if (!location.pathname.toLocaleLowerCase().includes(PAGES.LOGIN)) {
      showLoader();
      setAthuLoading();
    }
    try {
      clearOrderHistoryCache();
      const response = await axiosInstance.post("Logout");
      setUser(null);
      clearLoginReturnUrl();
      window.location.href = "/login";
    } catch (e) {}
  };

  const getClarificationItem = async (oid) => {
    const result = await axiosInstance.post("MyCart/GetOrderClarification", {
      userId: String(userId),
      orderId: String(oid ?? OrderId),
    });
    setClarificationItem(null);
    if (result.data) {
      let res = result.data;
      if (res.statusCode != -1 && isValidArray(res.data)) {
        setClarificationItem(res.data);
        return res.data;
      }
    }
    return null;
  };

  const refreshCartItem = async () => {
    try {
      const response = await axiosInstance.post("MyCart/GetMyCartItem", {
        UserID: String(userId),
        OrderID: String(OrderId ?? "0"),
      });
      if (response.data) {
        globalcontext.setCartItem(response.data);
        globalcontext.setOrderId(response.data.orderid);
        getClarificationItem(response.data.orderid);
        if (isValidArray(response.data?.cartItem) === false) {
          globalcontext.setCartItem((prev) => ({ ...prev, cartItem: [] }));
        }
      }
      return response.data ?? null;
    } catch (e) {}
    return null;
  };
  useEffect(() => {
    refreshCartItemRef.current = refreshCartItem;
  });
  const checkInternational = async () => {
    try {
      await axiosInstance
        .post("Shipping/CheckInternationalShipping", {
          userId: String(userId),
          orderId: "0",
        })
        .then((response) => {
          if (response.data && typeof response.data === "boolean") {
            globalcontext.setIsInterNational(response.data);
          } else {
            globalcontext.setIsInterNational(false);
          }
        })
        .catch((error) => {
          globalcontext.setIsInterNational(false);
        });
    } catch {}
  };
  const cancelPreviousOrder = async (orderid) => {
    const cartItem = globalcontext.CartItem;
    if (userId && cartItem) {
      var params = {
        orderId: String(orderid ?? cartItem.orderid),
        userId: String(userId),
      };
      try {
        let response = await axiosInstance
          .post("MyCart/CancelPreviousOrder", params)
          .catch((error) => console.log(error.message));

        if (response && response.data !== null) {
          refreshCartItem();
        }
      } catch (e) {}
    }
  };

  useEffect(() => {
    const cartItem = globalcontext.CartItem;
    if (cartItem && isValidArray(cartItem.cartItem)) {
      clientCartItemRef.current = cartItem;
      const productsKey = `${cartItem.orderid}:${cartItem.cartItem
        .map((item) => item.prod_id)
        .sort((a, b) => a - b)
        .join(",")}`;
      if (productsKey !== cartProductsKeyRef.current) {
        cartProductsKeyRef.current = productsKey;
        checkPickupOnly(cartItem);
        checkArosol(cartItem);
      }
      refreshShippingAddress();
      checkInternational();
    } else {
      clientCartItemRef.current = null;
      if (cartItem && Array.isArray(cartItem.cartItem)) {
        cartProductsKeyRef.current = null;
        aerosolRequestRef.current++;
        pickupOnlyRequestRef.current++;
        globalcontext.setAerosol(null);
        globalcontext.setPickupOnlyProduct([]);
      }
    }
  }, [globalcontext.CartItem]);

  useEffect(() => {
    if (isAuthenticated) {
      const handleAddtoCartEvent = (event) => {
        const { productid, qty, type } = event.detail;
        handleAddtoCart(productid, qty, type);
      };

      const handleWishListEvent = (event) => {
        const { productid, type } = event.detail;
        handleWishList(type, productid);
      };

      window.addEventListener("addToCartReactFunction", handleAddtoCartEvent);
      window.addEventListener("updateCartReactFunction", handleAddtoCartEvent);
      window.addEventListener("wishListReactFunction", handleWishListEvent);
      window.addEventListener("logoutReactFunction", () => {
        if (isAuthenticated && authLoading === false) globalcontext.setIsTimeout(true);
      });
      loadStaticData();

      return () => {
        window.removeEventListener("addToCartReactFunction", handleAddtoCartEvent);
        window.removeEventListener("updateCartReactFunction", handleAddtoCartEvent);
        window.removeEventListener("wishListReactFunction", handleWishListEvent);
      };
    } else {
      getCountryList();
    }
  }, [isAuthenticated]);

  const loadStaticData = async () => {
    await Promise.all([
      checkInternational(),
      checkPickupOnly(null),
      checkDropshipmentUser(),
      loadPaymentOption(),
      loadStoredCard(),
      checkOrderNoMandatory(),
      get_po_number_rules(),
      get04MobileNumber(),
      SubUrbDataAll(null),
      getCountryList(),
      loadBillAddress(),
      getShippingAddress(),
      getMyAddressBook(),
      get_po_number_rules(),
      loadAllWishList(),
      getBrandList(),
      getCompatibleList(),
    ]);
  };

  const checkoutStateRef = useRef({});
  useEffect(() => {
    checkoutStateRef.current = {
      addressType: globalcontext.addressType,
      selectedAddressId: globalcontext.selectedAddressId,
      changeAddressClicked: globalcontext.changeAddressClicked,
      shippingAddress: globalcontext.shippingAddress,
      CartItem: globalcontext.CartItem,
      smsNumber: globalcontext.smsNumber,
      billingAddress: globalcontext.billingAddress,
      addressOrderId: globalcontext.addressOrderId,
    };
  });

  const SHIP_ADDRESS_COMPARE_KEYS = [
    "shipTo",
    "shipAddress1",
    "shipAddress2",
    "shipAddress3",
    "shipCity",
    "shipState",
    "shipZip",
    "shipCountry",
    "shipPhone",
    "shipAttention",
    "deliveryInst",
  ];

  const isSameShipAddress = (a, b) => {
    if (!a || !b) return false;
    return SHIP_ADDRESS_COMPARE_KEYS.every((key) => String(a[key] ?? "") === String(b[key] ?? ""));
  };

  const cartQuoteSignature = (cart) => {
    if (!cart) return "";
    return [cart.orderid ?? "", cart.totalcost ?? "", cart.totalItem ?? ""].join("~");
  };

  const refreshShippingAddress = async () => {
    try {
      const response = await axiosInstance.post("Shipping/getShippingAddress", {
        userId: String(userId),
      });
      if (!response.data) return;
      globalcontext.setShippingAddressOriginal(response.data);

      const { addressType, selectedAddressId, changeAddressClicked, shippingAddress, CartItem, addressOrderId } =
        checkoutStateRef.current;
      const hasOverride = addressType != null || selectedAddressId != null;
      const currentOrderId = CartItem ? CartItem.orderid : null;

      if (
        hasOverride &&
        addressOrderId != null &&
        currentOrderId != null &&
        String(addressOrderId) !== String(currentOrderId)
      ) {
        globalcontext.setAddressType(null);
        globalcontext.setSelectedAddressId(null);
        globalcontext.setNewAddress(null);
        globalcontext.setAddressOrderId(null);
        globalcontext.setShippingAddress(response.data);
        return;
      }

      if (hasOverride || changeAddressClicked === true) return;

      if (isSameShipAddress(shippingAddress, response.data)) return;

      globalcontext.setShippingAddress(response.data);
      globalcontext.setNewAddress(null);
    } catch (error) {
      console.error(error.message);
    }
  };

  const refreshMobileNumber = async () => {
    try {
      const response = await axiosInstance.post("Shipping/GetMobileNumber", {
        userId: String(userId),
      });
      const next = response.data ? response.data : "";

      if (globalcontext.smsEditInProgress && globalcontext.smsEditInProgress.current === true) return;

      const current = checkoutStateRef.current.smsNumber;
      if (current !== null && current !== undefined && String(current) === String(next)) return;

      globalcontext.setSmsNumber(next);
    } catch (error) {
      console.error(error.message);
    }
  };

  const BILL_ADDRESS_COMPARE_KEYS = [
    "billTo",
    "billAttention",
    "billAddress1",
    "billAddress2",
    "billAddress3",
    "billCity",
    "billSuburb",
    "billState",
    "billZip",
    "billCountry",
    "billPhone",
  ];

  const refreshBillAddress = async () => {
    try {
      const response = await axiosInstance.post("Shipping/getBillingAddress", {
        userId: String(userId),
      });
      if (!response.data || response.data === "") return;

      const current = checkoutStateRef.current.billingAddress;
      if (
        current &&
        BILL_ADDRESS_COMPARE_KEYS.every((k) => String(current[k] ?? "") === String(response.data[k] ?? ""))
      )
        return;

      globalcontext.setBillingAddress(response.data);
      globalcontext.setBillingAddressOriginal(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const refreshSettings = async () => {
    if (refreshRef.current === null && isAuthenticated) {
      refreshRef.current = true;
    } else {
      return;
    }
    const cartBefore = cartQuoteSignature(checkoutStateRef.current.CartItem);
    try {
      const [freshCart] = await Promise.all([
        refreshCartItem(),
        checkInternational(),
        checkPickupOnly(null),
        checkDropshipmentUser(),
        loadPaymentOption(),
        loadStoredCard(),
        checkOrderNoMandatory(),
        get_po_number_rules(),
        refreshMobileNumber(),
        refreshBillAddress(),
        refreshShippingAddress(),
        loadAllWishList(),
        checkOrderClarification(),
      ]);
      const cartAfter = cartQuoteSignature(freshCart);
      if (freshCart && cartBefore && cartAfter !== cartBefore) {
        clearSelectedShipService();
      }
    } catch (e) {
      console.error("Error in refreshSettings:", e);
    } finally {
      refreshRef.current = null;
    }
  };

  const clearSelectedShipService = () => {
    globalcontext.setShipService(null);
    globalcontext.setShippingCost(null);
    globalcontext.setShippingMode(null);
    globalcontext.setShippingCode(null);
  };
  const setSelectedShipService = (item) => {
    console.log("setSelectedShipService orderid called with item:", item);
    if (item) {
      globalcontext.setShipService(item);
      globalcontext.setShippingCost(item.cost);
      globalcontext.setShippingMode(item.value);
      globalcontext.setShippingCode(item.shipcode);
    }
  };

  const loadPaymentOption = async () => {
    axiosInstance
      .post("Shipping/GetPaymentoption", { userId: String(userId) })
      .then((response) => {
        if (response.data !== "" && response.data !== null) {
          globalcontext.setPaymentOption(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };
  const checkDropshipmentUser = async () => {
    axiosInstance
      .post("Shipping/CheckDropShipment", { userId: String(userId) })
      .then((response) => {
        if (response.data !== null) {
          globalcontext.setIsDropshipmentUser(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  const loadStoredCard = async () => {
    axiosInstance
      .post("Shipping/loadStoredCard", { userId: String(userId) })
      .then((response) => {
        if (response.data !== "" && response.data !== null) {
          globalcontext.setStoredCard(response.data);
          var defaultCard = response.data.find((item) => item.isdefault === true);
          if (!defaultCard) {
            var defaultCard = response.data.find((item) => item.IsExpired === false);
          }
          if (defaultCard) globalcontext.setSelectedCard(defaultCard);
          else {
            globalcontext.setSelectedCard(null);
          }
        } else {
          globalcontext.setStoredCard([]);
        }
      })
      .catch((error) => console.log(error.message));
  };

  const updateDefaultCard = async (uuid) => {
    var payload = {
      uuid: uuid,
      userid: String(userId),
    };
    const response = await axiosInstance.post("MyWallet/updateDefault", payload);
    loadStoredCard();
    return response.data || null;
  };

  const removeStoreCard = async (uuid) => {
    var payload = {
      uuid: uuid,
      userid: String(userId),
    };
    const response = await axiosInstance.post("MyWallet/Remove", payload);
    loadStoredCard();
    return response.data || null;
  };
  const GetPriceTableData = async (productId, productCode) => {
    var payload = {
      type: "PriceTable",
      userid: String(userId),
      prodid: productId,
      productCode: productCode,
    };
    const response = await axiosInstance.post("GetPriceTable/MouseHover", payload);
    return response.data || null;
  };

  const getFamilyProducts = async (familyId, type) => {
    var payload = {
      key: type,
      familyId: familyId,
      userId: String(userId ?? 999),
      priceCode: String(priceCode ?? 3),
    };

    const response = await axiosInstance.post("ProductNew/GetFamilyProduct", payload);
    if (response && response.data) return response.data;
    else return null;
  };
  const getSuggestionProducts = async (familyId, productId, signal) => {
    var payload = {
      productId: productId,
      familyId: familyId,
      userId: String(userId ?? 999),
      key: "family",
      priceCode: String(priceCode ?? 3),
    };

    const response = await axiosInstance.post("ProductNew/GetSuggestionProduct", payload, signal ? { signal } : {});
    if (response && response.data) return response.data;
    else return null;
  };
  const getSubFamilyDetails = async (familyId) => {
    var payload = {
      familyId: familyId,
      userId: String(userId ?? 999),
      priceCode: String(priceCode ?? 3),
    };

    const response = await axiosInstance.post("ProductNew/GetSubFamilyDetails", payload);
    if (response && response.data) return response.data;
    else return null;
  };

  const getProductPrice = async (pid) => {
    var payload = { productId: String(pid), userId: String(userId) };

    const response = await axiosInstance.post("ProductNew/getProductPrice", payload);
    if (response && response.data) return response.data;
    else return null;
  };

  const getFamilyFilter = async (fid) => {
    var payload = { familyId: String(fid), userId: String(userId) };

    const response = await axiosInstance.post("ProductNew/FamilyPageFilter", payload);
    if (response && response.data) return response.data;
    else return null;
  };
  const getFamilyAttribute = async (fid) => {
    var payload = { familyId: String(fid), userId: String(userId) };

    const response = await axiosInstance.post("ProductNew/GetFamilyPageAttribute", payload);
    if (response && response.data) return response.data;
    else return null;
  };

  const getOrderHistory = async (data) => {
    try {
      const paramsObj = {
        ...data,
        userId: String(userId),
        userRole: String(userRole),
        companyId: String(companyId),
      };
      const response = await axiosInstance.post("MyOrderHistory/GetOrderHistory", paramsObj);
      if (response && response.data) return response.data;
      else return null;
    } catch (e) {
      return null;
    }
  };
  const deleteOrderHistory = async (data) => {
    try {
      const paramsObj = {
        ...data,
        userId: String(userId),
        userRole: String(userRole),
        companyId: String(companyId),
      };
      const response = await axiosInstance.post("MyOrderHistory/Delete", paramsObj);
      if (response && response.status === 200) return response.data;
      else return null;
    } catch (e) {
      return null;
    }
  };
  const getPendingOrderHistory = async (data) => {
    try {
      const paramsObj = {
        userId: String(userId),
        userRole: String(userRole),
        companyId: String(companyId),
      };
      const response = await axiosInstance.post("MyOrderHistory/GetPendingOrderHistory", paramsObj);
      if (response && response.data) return response.data;
      else return null;
    } catch (e) {
      return null;
    }
  };

  const getOrderDetail = async (orderId) => {
    const paramsObj = {
      orderId: String(orderId),
      userId: String(userId),
      userRole: String(userRole),
      companyId: String(companyId),
    };
    const response = await axiosInstance.post("MyOrderHistory/GetOrderDetail", paramsObj);
    if (response && response.data) {
      return response.data;
    } else return null;
  };
  const sendInvoiceSignal = async (orderId, invoiceNo, page = "") => {
    let response = null;
    try {
      if (page == "PAYACCOUNT") {
        response = await axiosInstance.post(
          "PayAccount/SendInvoiceSignal",
          {
            invoiceNo: String(invoiceNo),
          },
          {
            responseType: "blob",
          },
        );
      } else {
        response = await axiosInstance.post(
          "MyOrderHistory/GetInvoiceSignal",
          {
            orderId: String(orderId),
            invoiceNo: String(invoiceNo),
            userId: String(userId ?? 0),
            userRole: String(userRole ?? 0),
            companyId: String(companyId ?? 0),
          },
          {
            responseType: "blob",
          },
        );
      }
      try {
        if (response) {
          const json = response.data;
          const fileSize = json.size || 0;
          if (response.data && fileSize === 0) {
            showErrorSnackbar("Invoice download failed. Please try again");
            console.error("Download failed", response.status);
            return json;
          }
        } else {
          showErrorSnackbar("Invoice download failed. Please try again");
          return null;
        }
      } catch (error) {
        showErrorSnackbar("Invoice download failed. Please try again");
        console.error("Download failed", error);
      }
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Invoice_${invoiceNo}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      showErrorSnackbar("Invoice download failed. Please try again");
    }
  };

  const reorderOrderItem = async (items) => {
    const { setCartItem, OrderId } = globalcontext;
    const paramsObj = {
      reorderItems: items,
      userId: String(userId),
      userRole: String(userRole),
      companyId: String(companyId),
      orderId: String(OrderId),
    };
    try {
      const response = await axiosInstance.post("MyOrderHistory/ReOrderAll", paramsObj);
      if (response && response.data) {
        setCartItem(response.data);
        const bPids = new Set(items.map((obj) => obj.productId));
        const cartItem = response.data.cartItem;
        const productData = cartItem.filter((obj) => bPids.has(obj.prod_id));
        return productData;
      } else return null;
    } catch (e) {
      console.error("Error in reorderOrderItem:", e);
      return null;
    }
  };
  const getAttachments = async (id, key) => {
    var payload = { productId: id, key: String(key) };

    const response = await axiosInstance.post("ProductNew/GetAttachments", payload);
    if (response && response.data) return response.data;
    else return null;
  };
  const getStockStatus = async (productId) => {
    var payload = {
      sku: String(productId),
      userId: String(userId ?? 999),
      priceCode: String(priceCode ?? 3),
    };

    const response = await axiosInstance.post("ProductNew/GetStockStatus", payload);
    if (response && response.data) return response.data;
    else return null;
  };

  const getProductData = async (productId, familyId = "") => {
    var payload = {
      productId: String(productId),
      familyId: String(familyId),
      userId: String(userId ?? 999),
      priceCode: String(priceCode ?? 3),
    };

    const response = await axiosInstance.post("ProductNew/GetProductData", payload);
    if (response && response.data) return response.data;
    else return null;
  };

  const addToWishList = async ({ listId, productId }) => {
    try {
      if (listId === 0) return false;
      var data = {
        userId: parseInt(userId),
        listId: parseInt(listId),
        productId: String(productId),
      };
      const response = await axiosInstance.post("MyFavoriteList/AddItemList", data);
      if (response && response.data && response.data.data) {
        showWishListAddToaster();
        globalcontext.setWishListAll(JSON.parse(response.data.data));
        return JSON.parse(response.data.data);
      }
    } catch (error) {
      console.error("API MyFavoriteList/AddItemList", error);
    }
    return null;
  };
  const addExcelToWishList = async ({ listId, productId }) => {
    try {
      if (listId === 0) return false;
      var data = {
        userId: parseInt(userId),
        listId: parseInt(listId),
        productId: productId,
      };
      const response = await axiosInstance.post("MyFavoriteList/AddBulkItemList", data);
      if (response && response.data && response.data.data) {
        showWishListAddToaster();
        return JSON.parse(response.data.data);
      }
      return null;
    } catch (error) {
      console.error("API MyFavoriteList/AddItemList", error);
      return null;
    }
  };
  const getFavouriteListDetails = async (listId) => {
    try {
      if (listId === 0) return false;
      var data = {
        userId: parseInt(userId),
        listId: parseInt(listId),
      };
      const response = await axiosInstance.post("MyFavoriteList/GetFavouriteListItems", data);
      if (response && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("API MyFavoriteList/AddItemList", error);
      return null;
    }
  };

  const exportHtml2pdfFile = async (container) => {
    var payload = { html: String(container) };
    const response = await axiosInstance.post("GetStaticData/ExportPdf", payload, { responseType: "stream" });
    if (response && response.data) {
      return JSON.parse(response.data);
    } else return null;
  };
  const sendMailAttachments = async ({ fileName, fullName, phone, message, url }) => {
    var payload = {
      userId: String(userId),
      fromid: emailAddress,
      familyName: fileName,
      currenturl: url,
      fullname: fullName,
      phone: phone,
      downloadrequire: message,
    };

    const response = await axiosInstance.post("MailSend/SendDownload", payload);
    if (response && response.data) return response.data;
    else return null;
  };
  const sendQuestionMail = async ({ fileName, fullName, phone, message, url }) => {
    var payload = {
      userId: String(userId),
      fromid: emailAddress,
      familyName: fileName,
      currenturl: url,
      fullname: fullName,
      phone: phone,
      question: message,
    };

    const response = await axiosInstance.post("MailSend/AskQuestionMail", payload);
    if (response && response.data) return response.data;
    else return null;
  };

  const downloadPdf = async (fileName) => {
    const response = await fetch(`https://localhost:5001/api/download-pdf/${fileName}`, {
      method: "GET",
    });

    if (!response.ok) {
      console.error("Download failed");
      return;
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
  const getCategoryDetails = async (data) => {
    var payload = {
      ...data,
      userId: String(userId),
    };

    const response = await axiosInstance.post("Category/GetCategoryDetails", payload);
    if (response && response.data) return response.data;
    else return null;
  };
  const fetchNewProductsAlgolia = async () => {
    try {
      const products = await fetchProducts("NEW_PRODUCTS");
      globalcontext.setAlgoliaProducts((prev) => ({
        ...prev,
        NEWPRODUCTS: products,
      }));
    } catch (e) {
      console.error("fetchNewProductsAlgolia", e);
    }
  };
  const fetchClearanceProductsAlgolia = async () => {
    try {
      const products = await fetchProducts("CLEARANCE_PRODUCTS");
      globalcontext.setAlgoliaProducts((prev) => ({
        ...prev,
        CLEARANCEPRODUCTS: products,
      }));
    } catch (e) {
      console.error(e);
    }
  };
  const fetchSpecialProductsAlgolia = async () => {
    try {
      const products = await fetchProducts("SPECIAL_PRODUCTS");
      globalcontext.setAlgoliaProducts((prev) => ({
        ...prev,
        SPECIALPRODUCTS: products,
      }));
    } catch (e) {
      console.error(e);
    }
  };
  const fetchTrendingItemsAlgolia = async () => {
    try {
      const products = await fetchTrendingProducts();
      globalcontext.setAlgoliaProducts((prev) => ({
        ...prev,
        TRENDINGPRODUCTS: products,
      }));
    } catch (e) {
      console.error(e);
    }
  };

  const getBrandList = async () => {
    try {
      const response = await axiosInstance.get("GetStaticData/GetManufacturerList");
      if (response && response.data) {
        globalcontext.setBrandList(response.data);
      }
    } catch (e) {
      console.error("brand list", e);
    }
  };
  const getCompatibleList = async () => {
    try {
      const response = await axiosInstance.get("CategoryPage/GetCompatibleList");
      if (response && response.data) {
        setCompatibleList(response.data);
      }
    } catch (e) {
      console.error("compatible list", e);
    }
  };
  const addToCardQuickOrder = async ({ userId, itemList }) => {
    try {
      var params = {
        userid: userId,
        itemList: itemList,
        priceCode: priceCode,
      };
      const response = await axiosInstance.post("AddtoCart/QuickOrderAddtoCartLite", params);
      if (response && response.data) return response.data;
      else return null;
    } catch (error) {
      console.error("API MyFavoriteList/AddItemList", error);
      throw error;
    }
  };

  const addToCardLineEntry = async ({ sku, qty }) => {
    try {
      var params = {
        userid: String(userId),
        sku: sku,
        qty: qty,
        priceCode: String(priceCode),
        orderId: String(globalcontext.OrderId),
      };
      const response = await axiosInstance.post("AddtoCart/AddtoCartLineEntry", params);
      if (response && response.data) return response.data;
      else return null;
    } catch (error) {
      console.error("API MyFavoriteList/AddItemList", error);
      throw error;
    }
  };
  const checkOrderClarification = async () => {
    if (window.location.pathname.toLocaleLowerCase().includes(PAGES.CHECKOUT)) {
      return;
    }
    axiosInstance
      .post("MyCart/CheckOrderClarification", {
        userId: String(userId),
        orderId: String(globalcontext.OrderId),
      })
      .then((response) => {
        if (response.data && response.data.statusCode === 0) {
          setIsOrderClarification(true);
        } else {
          setIsOrderClarification(false);
        }
      })
      .catch((error) => {
        setIsOrderClarification(false);
      });
  };
  const deletePendingOrderProduct = async (data) => {
    try {
      console.log("deletePendingOrderProduct called with data:", data);
      const paramsObj = {
        orderId: String(data.order_id),
        prodid: String(data.prod_id),
      };
      const response = await axiosInstance.post("MyOrderHistory/PendingProductDelete", paramsObj);
      if (response && response.status === 200) return response.data;
      else return null;
    } catch (e) {
      return null;
    }
  };
  const getOrderItems = async (orderId, pageNo = 1) => {
    try {
      if (orderId) {
        const response = await axiosInstance.post("MyCart/GetCartItemPaginate", {
          userId: String(userId),
          orderId: String(orderId),
          pageNo: pageNo,
        });

        if (response && response.data) {
          return response.data;
        } else return null;
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  };

  const updateClientItem = async (qty) => {
    const cartItem = clientCartItemRef.current;
    if (cartItem && isValidArray(cartItem.cartItem)) {
      setCartItem((prevCart) => ({
        ...cartItem,
        totalItem: cartItem.totalItem + qty,
      }));
    } else {
      setCartItem((prevCart) => ({
        cartItem: [],
        totalItem: qty,
      }));
    }
  };

  const fetchCategorySliderData = async () => {
    try {
      const response = await fetch(
        "https://cdn.wes.com.au/WesReact/categorySlider/categorySlider.txt?v=" + new Date().getTime(),
      );
      const data = await response.json();
      if (data && data.category) {
        try {
          const sortedCategorySlider = data.category?.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: "base",
            }),
          );
          setCategorySlider(sortedCategorySlider);
        } catch (e) {
          console.error("Error sorting category slider data:", e);
          setCategorySlider(data.category);
        }
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };
  const fetchLinkedCategoryData = async () => {
    try {
      const response = await axiosInstance.get("GetStaticData/GetLikedCategoryList");
      if (response && response.data && isValidArray(response.data)) setLinkedCategoryData(response.data);
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };
  const fetchNewCategory = async () => {
    try {
      const res = await axiosInstance.post("CategoryPage/GetSubCategory", {
        catUrl: "new-products",
      });
      if (res && res.data && isValidArray(res.data)) setNewCategoryData(res.data.slice(0, 8));
    } catch (error) {
      console.error("Error fetching new category:", error);
    }
  };
  const contextValue = useStableCallbacks({
    fetchCategorySliderData,
    fetchLinkedCategoryData,
    updateClientItem,
    handleAddtoCart,
    handleWishList,
    removwItemWhishList,
    handleDeleteCartItem,
    deletingProdIds,
    clearSelectedShipService,
    setSelectedShipService,
    logout,
    logoutReset,
    loadBillAddress,
    submitOrderMailSend,
    cancelPreviousOrder,
    loadStoredCard,
    removeStoreCard,
    updateDefaultCard,
    checkInternational,
    get04MobileNumber,
    getShippingAddress,
    GetPriceTableData,
    loadAllWishList,
    addToWishList,
    getFavouriteListDetails,
    getFamilyProducts,
    getSuggestionProducts,
    getSubFamilyDetails,
    getAttachments,
    sendMailAttachments,
    getProductPrice,
    getFamilyFilter,
    getStockStatus,
    getProductData,
    exportHtml2pdfFile,
    getOrderHistory,
    getPendingOrderHistory,
    getOrderDetail,
    sendInvoiceSignal,
    getOrderItems,
    reorderOrderItem,
    createNewList,
    deleteNewList,
    getAllWishList,
    logoutFunction,
    refreshCartItem,
    addExcelToWishList,
    deleteOrderHistory,
    getMyAddressBook,
    getEditAddressBook,
    saveAddressBook,
    sendAddressUpdateOTP,
    updateAddressMail,
    getCountryList,
    getCategoryDetails,
    fetchNewProductsAlgolia,
    fetchClearanceProductsAlgolia,
    fetchTrendingItemsAlgolia,
    fetchSpecialProductsAlgolia,
    sendQuestionMail,
    checkOrderNoMandatory,
    get_po_number_rules,
    refreshSettings,
    checkOrderClarification,
    addToCardQuickOrder,
    addToCardLineEntry,
    fetchBillinfo,
    getFamilyAttribute,
    getClarificationItem,
    fetchNewCategory,
    deletePendingOrderProduct,
  });

  return <GlobalFunctionContext.Provider value={contextValue}>{children}</GlobalFunctionContext.Provider>;
};

export const useGlobalFunction = () => useContext(GlobalFunctionContext);
